import { Skeleton } from "@mui/material";
import { FC } from "react";
import { TableSkeletonProps } from "../../interfaceTypes";

export const DashboardAssignedTaskSkeleton: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <Skeleton key={index}
        variant="text"
        height='80px'
        translate='no'
        sx={{ width: '100%', transformOrigin: '0 10%', transform: 'scale(1, 0.80)' }}
      />
    ))}
  </>
);